import "@/global.scss";
import "@/global";
import React from "react";
import PageView from "@/pages";
import { CrosshairsDataProvider } from "@/providers";
import GlobalTransition from "@/components/GlobalTransition";
import { QueryClient, QueryClientProvider } from "react-query";
import { ConfigProvider } from "antd-mobile";
import zhCN from "antd-mobile/es/locales/zh-CN";
import { HashRouter } from "react-router-dom";
/**
 * @see https://mobile.ant.design/zh/guide/css-variables/#css-变量自动降级
 */
import "antd-mobile/bundle/css-vars-patch.css";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      // retryOnMount: false,
    },
  },
});

interface IAppProps {}
const App: React.FC<IAppProps> = () => {
  return (
    <React.Suspense fallback={<GlobalTransition theme="dark" />}>
      {/* @ts-ignore */}
      <QueryClientProvider client={queryClient}>
        <CrosshairsDataProvider>
          <ConfigProvider locale={zhCN}>
            <HashRouter>
              <PageView />
            </HashRouter>
          </ConfigProvider>
        </CrosshairsDataProvider>
      </QueryClientProvider>
    </React.Suspense>
  );
};

export default App;
